import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const InputtedMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Inputted extends Clazz {
    @Input("inputted")
    private _inputted: boolean = false;

    public get inputted(): boolean {
      return this._inputted;
    }

    public set inputted(value: boolean) {
      this._inputted = value;
    }

    @Output()
    public inputtedChange = new EventEmitter<boolean>();
  }

  return Inputted;
};

export const InputtedMixinInputs = ["inputted"];
